var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../utilities/media';
const El = styled.div `
  ${({ styleName }) => getStyleName(styleName)};
`;
const getStyleName = (x) => {
    switch (x) {
        case 'editorialTitle1':
            return editorialTitle1;
        case 'editorialTitle2':
            return editorialTitle2;
        case 'title1':
            return title1;
        case 'title2':
            return title2;
        case 'title3':
            return title3;
        case 'title4':
            return title4;
        case 'title5':
            return title5;
        case 'title6':
            return title6;
        case 'title7':
            return title7;
        case 'title8':
            return title8;
        case 'bodyLarge':
            return bodyLarge;
        case 'bodyRegular':
            return bodyRegular;
        case 'bodySmall':
            return bodySmall;
        case 'label':
            return label;
    }
};
export const Text = (_a) => {
    var { el, styleName, variant, children } = _a, props = __rest(_a, ["el", "styleName", "variant", "children"]);
    return (React.createElement(El, Object.assign({}, props, { as: el }, { styleName, variant }), children));
};
Text.displayName = 'Text';
// --- Text Variants
const variantInverted = css `
  ${({ variant, theme }) => variant === 'inverted'
    ? css `
          color: ${theme.palette.white.main};
        `
    : ''};
`;
const variantSecondary = css `
  ${({ variant, theme }) => variant === 'secondary'
    ? css `
          color: ${theme.palette.neutral.darker};
        `
    : ''};
`;
const variantTertiary = css `
  ${({ variant, theme }) => variant === 'tertiary'
    ? css `
          color: ${theme.palette.neutral.dark};
        `
    : ''};
`;
const variantLink = css `
  ${({ variant, theme }) => variant === 'link'
    ? css `
          color: ${theme.palette.cyan.main};
        `
    : ''};
`;
const variantPositive = css `
  ${({ variant, theme }) => variant === 'positive'
    ? css `
          color: ${theme.palette.positive.main};
        `
    : ''};
`;
const variantNegative = css `
  ${({ variant, theme }) => variant === 'negative'
    ? css `
          color: ${theme.palette.negative.main};
        `
    : ''};
`;
const variantLinkSecondary = css `
  ${({ variant, theme }) => variant === 'linkSecondary'
    ? css `
          color: ${theme.palette.neutral.darker};
          font-weight: ${theme.typography.font.weight.semibold};
        `
    : ''};
`;
const editorialTitle1 = css `
  font-size: 52px;
  line-height: 1.125;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 64px;
  `};
  ${variantInverted}
`;
const editorialTitle2 = css `
  font-size: 48px;
  line-height: 1.125;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 52px;
  `};
  ${variantInverted}
`;
const title1 = css `
  font-size: 38px;
  line-height: 1.125;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 48px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title2 = css `
  font-size: 32px;
  line-height: 1.25;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 38px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title3 = css `
  font-size: 28px;
  line-height: 1.25;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 32px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title4 = css `
  font-size: 24px;
  line-height: 1.25;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 28px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title5 = css `
  font-size: 22px;
  line-height: 1.25;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 24px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title6 = css `
  font-size: 20px;
  line-height: 1.25;
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${media.desktop `
    font-size: 22px;
  `};
  color: ${({ theme }) => theme.palette.midnight.main};
  ${variantInverted}
`;
const title7 = css `
  font-size: 18px;
  line-height: 1.25;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${variantInverted}
`;
const title8 = css `
  font-size: 16px;
  line-height: 1.25;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  ${variantInverted}
`;
const bodyLarge = css `
  font-size: 18px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.text};
  font-weight: ${({ theme }) => theme.typography.font.weight.normal};
  & strong {
    font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  }
  letter-spacing: 0.2px;
  ${variantInverted}
  ${variantSecondary}
  ${variantTertiary}
  ${variantLink}
  ${variantPositive}
  ${variantNegative}
`;
const bodyRegular = css `
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.text};
  font-weight: ${({ theme }) => theme.typography.font.weight.normal};
  & strong {
    font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  }
  ${variantInverted}
  ${variantSecondary}
  ${variantTertiary}
  ${variantLink}
  ${variantPositive}
  ${variantNegative}
`;
const bodySmall = css `
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.text};
  font-weight: ${({ theme }) => theme.typography.font.weight.normal};
  & strong {
    font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  }
  letter-spacing: 0.2px;
  ${variantInverted}
  ${variantSecondary}
  ${variantTertiary}
  ${variantLink}
  ${variantPositive}
  ${variantNegative}
  ${variantLinkSecondary}
`;
const label = css `
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.midnight.main};
  font-family: ${({ theme }) => theme.typography.font.family.text};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
`;
//# sourceMappingURL=Text.js.map